import React from "react";
import EvidencePin from "./EvidencePin";
import { useEvidenceModal } from "./EvidenceModalContext";

export const EvidenceCard = ({
  as: Tag = "article",
  variant = "paper",
  pin = "red",
  rotate = 0,
  tape = false,
  stamped = false,
  className = "",
  detail = null,
  nodeId,
  children,
  "data-cursor": dataCursor,
  onClick,
  onKeyDown,
  ...rest
}) => {
  const modal = useEvidenceModal();

  const openDetail = (event) => {
    if (!detail) return;
    if (event.target.closest?.("a, button, input, textarea, select, [role='button']")) return;
    event.preventDefault();
    event.stopPropagation();
    modal.open(detail);
  };

  const handleClick = (event) => {
    openDetail(event);
    onClick?.(event);
  };

  const handleKeyDown = (event) => {
    if (detail && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      openDetail(event);
    }
    onKeyDown?.(event);
  };

  return (
    <Tag
      className={`evidence-card evidence-card--${variant}${tape ? " has-tape" : ""} ${detail ? "has-detail" : ""} ${className}`}
      style={{ "--card-rotate": `${rotate || 0}deg` }}
      data-cursor={dataCursor ?? "hover"}
      data-has-detail={detail ? "true" : undefined}
      data-node={nodeId}
      tabIndex={detail ? 0 : undefined}
      onClick={detail ? handleClick : onClick}
      onKeyDown={detail ? handleKeyDown : onKeyDown}
      {...rest}
    >
      {pin ? <EvidencePin color={pin} className="evidence-card-pin" /> : null}
      {stamped ? <span className="evidence-card-stamp" aria-hidden="true" /> : null}
      {children}
    </Tag>
  );
};

export default EvidenceCard;
